import React from 'react';
interface QuotationTravellerInfoProps {
  travellers: string[];
  travelDates: string;
  totalNights: number;
  destinations: string[];
  paxCount: string;
}
export function QuotationTravellerInfo({
  travellers,
  travelDates,
  totalNights,
  destinations,
  paxCount
}: QuotationTravellerInfoProps) {
  return <div className="bg-blue-50/50 border border-blue-200 rounded-lg p-5 mb-6" data-id="element-1012">
      <div className="grid grid-cols-2 gap-x-8 gap-y-3" data-id="element-1013">
        <div data-id="element-1014">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-1015">
            Traveller(s):
          </p>
          <div className="space-y-0.5" data-id="element-1016">
            {travellers.map((traveller, index) => <p key={index} className="text-sm text-neutral-900" data-id="element-1017">
                {traveller}
              </p>)}
          </div>
        </div>

        <div data-id="element-1018">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-1019">
            Travel Dates:
          </p>
          <p className="text-sm text-neutral-900" data-id="element-1020">{travelDates}</p>
        </div>

        <div data-id="element-1021">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-1022">
            Total Nights:
          </p>
          <p className="text-sm text-neutral-900" data-id="element-1023">{totalNights} nights</p>
        </div>

        <div data-id="element-1024">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-1025">
            Destination(s):
          </p>
          <p className="text-sm text-neutral-900" data-id="element-1026">{destinations.join(', ')}</p>
        </div>

        <div className="col-span-2" data-id="element-1027">
          <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-1028">
            Pax Count:
          </p>
          <p className="text-sm text-neutral-900" data-id="element-1029">{paxCount}</p>
        </div>
      </div>
    </div>;
}